class Task {
  constructor(data) {
    this.id = data.id || '';
    this.title = data.title || '';
    this.start_time = data.start_time || null;
    this.end_time = data.end_time || null;
    this.is_high_priority = data.is_high_priority || false;
    this.scheduled_date = data.scheduled_date || null;
    this.category = data.category || null;
    this.is_completed = data.is_completed || false;
    this.duration = data.duration || null;
    this.completed_at = data.completed_at ? new Date(data.completed_at) : null;
    this.created_at = data.created_at ? new Date(data.created_at) : new Date();
    this.updated_at = data.updated_at ? new Date(data.updated_at) : new Date();
    this.due_date = data.due_date || null;
    this.notes_link = data.notes_link || null;
    this.task_type = data.task_type || null;
    this.recurring_formula = data.recurring_formula || null;
    this.user_id = data.user_id || '';
  }

  static fromJson(json) {
    return new Task({
      id: json.id,
      title: json.title,
      start_time: json.start_time,
      end_time: json.end_time,
      is_high_priority: json.is_high_priority,
      scheduled_date: json.scheduled_date,
      category: json.category,
      is_completed: json.is_completed,
      duration: json.duration,
      completed_at: json.completed_at,
      created_at: json.created_at,
      updated_at: json.updated_at,
      due_date: json.due_date,
      notes_link: json.notes_link,
      task_type: json.task_type,
      recurring_formula: json.recurring_formula,
      user_id: json.user_id
    });
  }

  toJson() {
    return {
      id: this.id,
      title: this.title,
      start_time: this.start_time,
      end_time: this.end_time,
      is_high_priority: this.is_high_priority,
      scheduled_date: this.scheduled_date,
      category: this.category,
      is_completed: this.is_completed,
      duration: this.duration,
      completed_at: this.completed_at ? this.completed_at.toISOString() : null,
      created_at: this.created_at.toISOString(),
      updated_at: this.updated_at.toISOString(),
      due_date: this.due_date,
      notes_link: this.notes_link,
      task_type: this.task_type,
      recurring_formula: this.recurring_formula,
      user_id: this.user_id
    };
  }

  get isCompleted() {
    return this.is_completed;
  }

  get isOverdue() {
    if (!this.due_date || this.is_completed) return false;
    return new Date() > new Date(this.due_date);
  }

  get formattedDueDate() {
    if (!this.due_date) return 'No due date';
    return new Date(this.due_date).toLocaleDateString();
  }

  markAsCompleted() {
    this.is_completed = true;
    this.completed_at = new Date();
    return this;
  }

  markAsPending() {
    this.is_completed = false;
    this.completed_at = null;
    return this;
  }

  toggleStatus() {
    if (this.is_completed) {
      return this.markAsPending();
    } else {
      return this.markAsCompleted();
    }
  }
  
  addSubtask(title) {
    const subtask = {
      id: Date.now().toString(),
      title,
      completed: false
    };
    this.subtasks.push(subtask);
    return subtask;
  }
  
  toggleSubtask(subtaskId) {
    const subtask = this.subtasks.find(st => st.id === subtaskId);
    if (subtask) {
      subtask.completed = !subtask.completed;
    }
    return this;
  }
  
  removeSubtask(subtaskId) {
    this.subtasks = this.subtasks.filter(st => st.id !== subtaskId);
    return this;
  }
}

export default Task; 